module.exports = __webpack_public_path__ + "static/media/makeinindia.28500a50.mp4";